import apiAsync from 'infrastructure/shared/api/api-async'

type SignedUrlResponse = {
  signed_url: string
  file_key: string
  expires_in_min: number
}

export default async function fetchDocumentLink(uuid: string): Promise<string> {
  const response = await apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: `documents/${uuid}/download`,
    method: 'GET',
    showLoading: false
  })

  if (!response?.success) {
    throw new Error(response?.message)
  }

  return response?.message || ''
}

export async function fetchSignedDownloadURL(
  fileKey: string
): Promise<SignedUrlResponse> {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: `file/signed-download-url`,
    method: 'POST',
    obj: {
      filename: fileKey
    },
    showLoading: false
  })
}
